<template>
  <v-text-field
    v-bind="$attrs"
    :model-value="dateDisplay"
    prepend-inner-icon="mdi-calendar"
    readonly
    @click:prepend-inner="
      dialog = true;
      prevTime = props.modelValue?.datetimeValue.getTime() ?? 0;
    "
  />
  <v-dialog v-model="dialog" max-width="328">
    <v-card>
      <v-date-picker v-model="dateModel" />
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { DateObject } from "@/classes";
import { computed, ref, watch } from "vue";

const props = defineProps<{
  modelValue: DateObject | null;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", item: DateObject | null): void;
  (e: "change"): void;
}>();

const dialog = ref(false);
const prevTime = ref(0);

watch(
  () => dialog.value,
  () => {
    if (!dialog.value) {
      const currTime = props.modelValue?.datetimeValue.getTime() ?? 0;
      if (currTime !== prevTime.value) {
        emit("change");
      }
    }
  }
);

const dateModel = computed({
  get: () => {
    return props.modelValue ? props.modelValue.datetimeValue : null;
  },
  set: (value) => {
    emit("update:modelValue", value ? new DateObject(value) : null);
  },
});

const dateDisplay = computed(() => {
  if (props.modelValue)
    return props.modelValue.datetimeValue.toLocaleDateString();
  return "";
});
</script>
